const IconDaysInLevel = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48">
    {/* Clock circle */}
    <circle
      cx="24"
      cy="24"
      r="18"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
    />
    {/* Clock hands */}
    <line
      x1="24"
      y1="24"
      x2="24"
      y2="12"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
    <line
      x1="24"
      y1="24"
      x2="32"
      y2="24"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
    <circle cx="24" cy="24" r="2" fill="currentColor" />
  </svg>
);

export default IconDaysInLevel;
